module.exports = __webpack_public_path__ + "static/media/move-placeholder-square-purple.e58a4ee1.svg";